import {
  Bug,
  Sparkles,
  Zap,
  type LucideIcon,
} from "lucide-react";
import type { ChangelogCategory } from "../types/changelog.types";

export const CHANGELOGS_PAGE_SIZE = 20;

export const CATEGORY_LABELS: Record<ChangelogCategory, string> = {
  improvement: "Amélioration",
  new_feature: "Nouvelle fonctionnalité",
  bugfix: "Correctif",
};

export const CATEGORY_BADGE_VARIANTS: Record<ChangelogCategory, "default" | "success" | "warning"> = {
  improvement: "default",
  new_feature: "success",
  bugfix: "warning",
};

export const CATEGORY_ICONS: Record<ChangelogCategory, LucideIcon> = {
  improvement: Zap,
  new_feature: Sparkles,
  bugfix: Bug,
};

export const LAST_SEEN_POPUP_KEY = "last_seen_changelog_popup_id";
